import Keycloak from "keycloak-js";

console.log("Keycloak URL:", window.env);
const keycloak = new Keycloak({
  url: window.env.REACT_APP_KEYCLOAK_URL,
  realm: window.env.REACT_APP_KEYCLOAK_REALM,
  clientId: window.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export default keycloak;
